<template>
  <div class="flex flex-col gap-2 rounded-lg w-[300px] h-[450px] page-app-background border absolute top-[48px] right-[15px] z-[100] shadow-md p-1">
    <div class="flex flex-col flex-1 gap-1 overflow-auto">
      <div :class="'flex py-1 border gap-2 items-center' + (index % 2 != 0 ? ' dark:bg-gray-700 bg-gray-200' : '')"
        v-for="(c, index) in filtered"
        :key="index"
        @click="selectItem(c)">
        <UCheckbox v-if="multiSelect"
          v-model="c.select"/>
        <URadio
          v-else
          v-model="c.select"
          :value="true"/>
        <div class="flex flex-col">
          <span class="text-xs clickable" @click="openCorrection(c)">{{c.name}}</span>
          <span class="text-xs" >{{ rangeStr(c) }}</span>
          <div class="flex gap-3">
            <span class="text-xs">{{htmlDate(new Date(c.updated_at))}}</span>
            <span class="text-xs">{{c.email}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex pt-1">
      <span class="clickable text-xs" @click="newCorrection">+добавить</span>
      <div class="flex flex-1"/>
      <span class="clickable text-xs text-red-600" @click="reset">сбросить</span>
    </div>
    <div class="flex">
      <UInput class="w-full"
        placeholder="Поиск"
        v-model="search"/>
    </div>
    <div class="flex flex-col gap-1 ">
      <UCheckbox v-model="multiSelect">
        <template #label>
          <span class="text-xs">Выбрать несколько</span>
        </template>
      </UCheckbox>
      <UCheckbox v-model="onlyMy">
        <template #label>
          <span class="text-xs">Только мои</span>
        </template>
      </UCheckbox>
      <UCheckbox v-model="onlyActive">
        <template #label>
          <span class="text-xs">Только активные</span>
        </template>
      </UCheckbox>
    </div>
    <div class="flex p-1">
      <UButton class="flex w-full justify-center items-center"
         @click="selectClick">Выбрать</UButton>
    </div>
  </div>
</template>

<style scoped>

</style>

<script setup lang="ts">
import {CORRECTION_ON_DATE_STATE, SELECTED_CORRECTIONS_STATE, USERID_STATE} from "~/states/state";
import type {ICorrect} from "~/types/corrects";

const multiSelect = ref(false)
const emit = defineEmits<{
  onClose: []
}>()
const selectedCorrections = useState<number[]>(SELECTED_CORRECTIONS_STATE, ()=>[])
const corrections = useState<any[]>(CORRECTION_ON_DATE_STATE)
const userid = useState(USERID_STATE)
const current = ref([...selectedCorrections.value])
const filtered = ref([...corrections.value].filter((el: ICorrect)=>el.active))
const {htmlDate} = useHelpers()
const search = ref()
const onlyMy = ref()
const onlyActive = ref(true)

const selectClick = () => {
  close()
  selectedCorrections.value = [...current.value]
}

const selectItem = (c: any) => {
  if (!multiSelect.value) {
    current.value = []
    current.value.push(c.id)
    c.select = true
    corrections.value.forEach((cc: any) => {
      if (cc != c) cc.select = false
    })
  } else {
    c.select = !c.select

    if (c.select) current.value.push(c.id)
    else current.value.splice(current.value.findIndex(c.id), 1)
  }
}

const reset = () => {
  corrections.value.forEach((cc: any) =>  cc.select = false)
  selectedCorrections.value = []
  close()
}

const close = () => {
  emit('onClose')
}

watch(multiSelect, (val)=>{
  if (!val) {
    current.value = []
    corrections.value.forEach((cc: any) => {
      cc.select = false
    })
  }
})

const newCorrection = () => {
  close()
  navigateTo('/pricing/corrections/prop')
}

const openCorrection = (c: ICorrect) => {
  close()
  navigateTo('/pricing/corrections/prop?id=' + c.id)
}

watch([onlyMy, onlyActive], ([my, active])=>{
  if (my || active) {
    filtered.value = corrections.value.filter((c: any) => {
      return (!my || my && c.user_id == userid.value) &&
        (!active || active && c.active)
    })
  } else
    filtered.value = corrections.value
})

watch(search, (val)=>{
  if (val){
    filtered.value = corrections.value.filter((c: any) => {
      return c.email.toUpperCase().includes(val.toUpperCase()) ||
        c.name.toUpperCase().includes(val.toUpperCase())
    })
  } else
    filtered.value = corrections.value
})

const rangeStr = (c: ICorrect) => {
  if (!c.start && !c.finish) return 'постоянно'

  let res = ''

  if (c.start)
    res += 'с ' + htmlDate(new Date(c.start))

  if (c.finish) {
    if (c.start) res += ' - '
    res += 'по ' + htmlDate(new Date(c.finish))
  }

  res += ''

  return res
}
</script>
